import * as Sentry from '@sentry/nextjs'

// https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/
const initSentry = () => {
  Sentry.init({
    dsn: 'https://7a592a2ac2fb4b9ab519b111b94f6b2f@o64130.ingest.sentry.io/1258562',
    debug: false,
    environment: process.env.SENTRY_ENVIRONMENT,
    sampleRate: 0.1,
    maxBreadcrumbs: 50,
  })
}

export default initSentry
